module.exports = __webpack_public_path__ + "static/img/RoomBedSetting.495cf16b.png";